var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotFoundIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 161,
    viewBox: "0 0 200 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2971_159243)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_2971_159243)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41.7261,
    y: 38.7358,
    width: 117.449,
    height: 100.484,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.9761,
    y: 39.9858,
    width: 114.949,
    height: 97.9839,
    rx: 8.75,
    stroke: "#008BFF",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.7261 39.9858H149.175C154.007 39.9858 157.925 43.9033 157.925 48.7358V53.7982H42.9761V48.7358C42.9761 43.9034 46.8936 39.9858 51.7261 39.9858Z",
    fill: "#E8F5FC",
    stroke: "#008BFF",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_2971_159243)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41.7262,
    y: 38.7358,
    width: 117.449,
    height: 100.484,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.9762,
    y: 39.9858,
    width: 114.949,
    height: 97.9839,
    rx: 8.75,
    stroke: "#008BFF",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70 77.5L71.268 76.9928C72.4601 76.516 73.7899 76.516 74.982 76.9928L76.25 77.5",
    stroke: "#008BFF",
    strokeWidth: 1.875,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.75 77.5L125.018 76.9928C126.21 76.516 127.54 76.516 128.732 76.9928L130 77.5",
    stroke: "#008BFF",
    strokeWidth: 1.875,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 111.878C98.2032 111.877 96.5001 110.784 95.2181 108.859C93.939 106.939 93.1281 104.25 93.1293 101.25C93.1304 98.2495 93.9433 95.5617 95.2239 93.6424C96.5074 91.7188 98.2112 90.6268 100.008 90.6275C101.805 90.6282 103.508 91.7215 104.79 93.6461C106.07 95.5663 106.88 98.2547 106.879 101.255C106.878 104.256 106.065 106.943 104.785 108.863C103.501 110.786 101.797 111.878 100 111.878Z",
    fill: "#008BFF",
    stroke: "#008BFF",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.7277 105.68C93.4407 106.238 93.4248 106.896 93.681 107.469C95.0375 110.5 97.3578 112.499 99.9931 112.5C102.451 112.501 104.637 110.764 106.022 108.07C106.309 107.512 106.325 106.854 106.069 106.281C104.712 103.25 102.392 101.251 99.7569 101.25C97.2987 101.249 95.1132 102.986 93.7277 105.68Z",
    fill: "#E8F5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7261 39.9858H149.175C154.007 39.9858 157.925 43.9033 157.925 48.7358V53.7982H42.9761V48.7358C42.9761 43.9034 46.8936 39.9858 51.7261 39.9858Z",
    fill: "#E8F5FC",
    stroke: "#008BFF",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.0458,
    cy: 86.36,
    rx: 2.60997,
    ry: 2.60998,
    fill: "#008BFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.203,
    cy: 86.36,
    rx: 2.60996,
    ry: 2.60998,
    fill: "#008BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.399 90.6092C27.399 92.246 26.0721 93.5729 24.4353 93.5729C22.7985 93.5729 21.4716 92.246 21.4716 90.6092C21.4716 88.9724 22.7985 87.6455 24.4353 87.6455C26.0721 87.6455 27.399 88.9724 27.399 90.6092Z",
    stroke: "#008BFF",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2736 118.34L33.8117 122.669L37.8112 122.823L33.8963 124.713L32.2736 128.78L30.9601 124.713L28.0238 123.768L30.9601 122.823L32.2736 118.34Z",
    fill: "#008BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.997 98.7651L173.151 104.717L178.75 104.93L173.269 107.528L170.997 113.12L169.158 107.528L165.048 106.229L169.158 104.929L170.997 98.7651Z",
    fill: "#008BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.993 66.666L169.913 69.8476L172.588 71.0544L169.439 71.1724L167.281 73.3112L167.445 70.3585L165.697 68.9435L167.936 69.1554L169.993 66.666Z",
    fill: "#008BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7383 55.2846L32.2024 57.501L33.7454 58.554L31.6951 58.3893L29.9767 59.7142L30.5324 57.6643L29.6195 56.5385L31.0323 56.8623L32.7383 55.2846Z",
    fill: "#008BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.549 35.5496L175.337 25.7622",
    stroke: "#008BFF",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.6 47.9473H166.855",
    stroke: "#008BFF",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.5 34.2449V22.5",
    stroke: "#008BFF",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2971_159243",
    x: 21.7261,
    y: 28.7358,
    width: 157.449,
    height: 140.484,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.341176 0 0 0 0 0.498039 0 0 0 0 0.996078 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2971_159243"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.341176 0 0 0 0 0.498039 0 0 0 0 0.996078 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2971_159243",
    result: "effect2_dropShadow_2971_159243"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2971_159243",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_2971_159243",
    x: 21.7262,
    y: 28.7358,
    width: 157.449,
    height: 140.484,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.341176 0 0 0 0 0.498039 0 0 0 0 0.996078 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2971_159243"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.341176 0 0 0 0 0.498039 0 0 0 0 0.996078 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2971_159243",
    result: "effect2_dropShadow_2971_159243"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2971_159243",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2971_159243"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 160.494,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFoundIcon);
export default __webpack_public_path__ + "static/media/NotFoundIcon.406d9535f484838c570282c150ccfba1.svg";
export { ForwardRef as ReactComponent };